import { Theme } from '@mui/material/styles'

import headerStyles from '../header/index.styles'

const useStyles = {
  errorGridContainer: {
    marginTop: '230px',
  },
  errorGridContainerFullPage: {
    height: '100vh',
  },
  typographyWrapper: (theme: Theme) => ({
    margin: theme.spacing(2, 0, 1),
  }),
  ...headerStyles,
}
export default useStyles
